import { render, staticRenderFns } from "./AssetAndLiabilityManagement.vue?vue&type=template&id=3b930efe&scoped=true"
import script from "./AssetAndLiabilityManagement.vue?vue&type=script&lang=js"
export * from "./AssetAndLiabilityManagement.vue?vue&type=script&lang=js"
import style0 from "./AssetAndLiabilityManagement.vue?vue&type=style&index=0&id=3b930efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b930efe",
  null
  
)

export default component.exports